import { RouteTypes } from '@/types/config-types';

import { lazy } from 'react';

export const otherRoutes: RouteTypes[] = [
  {
    routeKey: 'home',
    path: '/',
    name: 'Home',
    component: lazy(() => import('@/pages/twin-showroom/Showroom')),
  },
  {
    routeKey: 'payment_status',
    path: '/payment',
    name: 'Payment Status',
    component: lazy(() => import('@/pages/payment/PaymentStatus')),
  },
  {
    routeKey: 'verify',
    path: '/verify',
    name: 'Verify',
    component: lazy(() => import('@/pages/others/Verify')),
  },
  {
    routeKey: 'twin_redirect',
    path: '/t/:twinName',
    name: 'Twin Redirect',
    component: lazy(() => import('@/pages/others/TwinRedirect')),
  },
  {
    routeKey: 'twin_demo',
    path: '/twin-demo/:demoToken',
    name: 'Twin Demo',
    component: lazy(() => import('@/pages/others/TwinDemo')),
  },
  {
    routeKey: 'help_and_feedback',
    path: '/feedback',
    name: 'Help & Feedback',
    component: lazy(() => import('@/pages/feedback/Feedback')),
  },
  {
    routeKey: 'watch_ai_video',
    path: '/watch/:videoId',
    name: 'Watch AI Video',
    component: lazy(() => import('@/pages/twin-studio/TwinVideoPlayback')),
  },
  {
    routeKey: 'get_twin',
    path: '/twin-landing',
    name: 'Get your Twin',
    component: lazy(() => import('@/pages/my-twin/twin-landing')),
  },
  {
    routeKey: 'studio_landing',
    path: '/twin-studio-landing',
    name: 'Get Started with Twin Studio',
    component: lazy(
      () => import('@/pages/twin-studio/studio-landing/StudioLanding')
    ),
  },
];
